import { Button, Stack, StackProps } from '@mui/material';
import ArrowLeftIcon from '@treyd-io/treyd-ui/icons/ArrowLeftIcon';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface StepLayoutProps {
  children: ReactNode;
  onMovingBackward?: () => void;
  layoutProps?: StackProps;
  containerProps?: StackProps;
}

export const StepLayout = (props: StepLayoutProps) => {
  const { children, onMovingBackward, layoutProps, containerProps } = props;
  const { t } = useTranslation();
  return (
    <Stack
      width="100%"
      maxWidth={960}
      marginTop={onMovingBackward ? { xs: 2, md: 4 } : { xs: 2, md: 10 }}
      marginX={{ xs: 'auto', md: 0 }}
      {...layoutProps}>
      <Stack marginX={{ xs: 'auto', md: 0 }} gap={3} {...containerProps}>
        {onMovingBackward && (
          <Button
            sx={{ alignSelf: 'flex-start' }}
            color="info"
            startIcon={<ArrowLeftIcon />}
            onClick={onMovingBackward}>
            {t('back')}
          </Button>
        )}
        {children}
      </Stack>
    </Stack>
  );
};
